/**
 * FroshBot connection constants, mirroring the iOS app's `Constants.swift`.
 *
 * One shared demo identity with credentials compiled in — the same deliberate
 * decision the iOS build made: anyone who reads the bundle can extract them,
 * and the blast radius is "can talk to FroshBot as the demo student." The
 * gateway keeps the shared profile read-only by never sending the app path the
 * profile-patch protocol, and conversations stay separate per session id.
 */

export const FROSHBOT_GATEWAY_URL =
  (import.meta.env.VITE_FROSHBOT_GATEWAY_URL as string | undefined) ??
  "wss://5ki46pdcx1.execute-api.us-east-1.amazonaws.com/prod";

export const COGNITO_REGION = "us-east-1";
export const COGNITO_CLIENT_ID = "6kpvsihpq4o57t6hab1m1ur62k";
export const DEMO_USERNAME = "demo@freshman.app";
export const DEMO_PASSWORD = "Fr0shDemo!05e63f8a9e214f17a304";

/** A turn that legitimately runs the tool loop takes the better part of a
 * minute; this exists to break a hang, not to police latency. */
export const TURN_TIMEOUT_MS = 180_000;

/**
 * What FroshBot may do inside the mini app. The iOS catalog has 63 actions;
 * this surface exposes the handful it can actually honour — data getters the
 * chat screen executes against the in-bundle services, and navigation.
 */
export const TOOL_CATALOG = `- getCourses — the student's enrolled courses with current grades, professors and schedules
- getAssignments — upcoming assignments with due dates and weights
- getGPA — the student's overall GPA
- getMatches — the student's top matches with compatibility percentages
- getBalance — Frosh Points balance and rank
- getTodayChallenge — today's campus challenge
- navigate {"destination": "..."} — offers the student a button that opens a screen; destinations: openHome, openStudy, openConnect, openProfile, openEarn, openCompete, openCalendar, openMatchesFeed`;

/**
 * Real-identity (tma) sessions get navigation only: the data getters execute
 * against the in-bundle demo mocks, and mock facts must never enter a real
 * user's chat (FOLLOWUPS 8.10). The server-side profile is the identity source.
 */
export const REAL_TOOL_CATALOG = `- navigate {"destination": "..."} — offers the student a button that opens a screen; destinations: openHome, openStudy, openConnect, openProfile, openEarn, openCompete, openCalendar, openMatchesFeed`;
